import {
  GET_QUOTE_BID_SEE_DETAIL,
  GET_QUOTE_BID_SEE_DETAIL_ERROR,
  GET_QUOTE_BID_SEE_DETAIL_SUCCESS,
  GET_RESULT_EXCEL,
  GET_RESULT_EXCEL_ERROR,
  GET_RESULT_EXCEL_SUCCESS,
  DIALOG_CLOSE_SUCCESS,
  DIALOG_OPEN_SUCCESS
} from './QuoteBid.actions'

const quoteBidState = {
  quoteBidDetail: {},
  loading: false,
  openSecondCall: false
}

/**
 * The Quote Bid' reducer.
 */
const QuoteBidReducer = (state = quoteBidState, { payload, type }) => {
  switch (type) {
    case GET_QUOTE_BID_SEE_DETAIL:
    case GET_RESULT_EXCEL: {
      return { ...state, loading: true, error: false }
    }
    case GET_QUOTE_BID_SEE_DETAIL_ERROR: {
      return { ...state, quoteBidDetail: {}, loading: false, error: true }
    }
    case GET_RESULT_EXCEL_ERROR: {
      return { ...state, loading: false, error: true }
    }
    case GET_QUOTE_BID_SEE_DETAIL_SUCCESS: {
      return {
        ...state,
        quoteBidDetail: payload.quoteBidDetail,
        loading: false,
        error: false
      }
    }
    case GET_RESULT_EXCEL_SUCCESS: {
      return { ...state, loading: false, error: false }
    }
    case DIALOG_CLOSE_SUCCESS: {
      return { ...state, openSecondCall: false }
    }
    case DIALOG_OPEN_SUCCESS: {
      return { ...state, openSecondCall: true }
    }
    default: {
      return state
    }
  }
}

export default QuoteBidReducer
